import { Result } from '@synergetx/puppet-interview-types';

// Firebase push-id object -> array of values. Empty/nullish input passes through unchanged,
// hence the union return type rather than plain T[].
export function objectToArray<T>(
    data: Record<string, T> | null | undefined,
): T[] | Record<string, T> | null | undefined {
    if (data && typeof data === 'object' && Object.keys(data).length) {
        return Object.keys(data).map((value) => data[value]);
    }
    return data;
}

// As objectToArray, but keeps each push id on the item as `key` for later db lookups.
export function objectToArrayWithKeys<T extends object>(
    data: Record<string, T> | null | undefined,
): (T & { key: string })[] | Record<string, T> | null | undefined {
    if (data && typeof data === 'object' && Object.keys(data).length) {
        return Object.keys(data).map((value) => ({ ...data[value], key: value }));
    }
    return data;
}

export const calculateResultsStats = (results: Result[]) => {
    const stats = [
        { name: 'Survey Not Started', value: 0, color: '#ff2e2e' },
        { name: 'Child Survey In-progress', value: 0, color: '#ff9a2e' },
        { name: 'Waiting on Assessor Survey', value: 0, color: '#BE33B8' },
        { name: 'Survey Complete', value: 0, color: '#12C828' },
    ];
    const notAnswered = 'Not Answered';

    if (results && results.length) {
        results.forEach((result) => {
            const someUnanswered = result.answers.some((a) => a.response === notAnswered);
            const someAnswered = result.answers.some((a) => a.response !== notAnswered);

            if (someUnanswered && someAnswered) {
                stats[1].value += 1;
            } else {
                stats[0].value += 1;
            }
        });
    }

    return stats.filter((stat) => stat.value > 0);
};
